// extracted by mini-css-extract-plugin
export default {"paper":"Editor_paper__hzX1v","notes":"Editor_notes__LVxK5"};